import { z } from "zod";
import { isoDateOnlySchema } from "../common/date.js";
export const availabilityQuerySchema = z
    .object({
    from: isoDateOnlySchema,
    to: isoDateOnlySchema,
})
    .refine((q) => q.from <= q.to, { message: "from doit être <= to", path: ["to"] });
